define('environments/test',{
  apiHost: 'https://landings-backend.test.mdirector.com',
  authHost: 'https://signup-backend.test.mdirector.com/auth/accessLandings',
  loginUrl: 'https://signup-backend.test.mdirector.com/auth/landings',
  defaultDomain: 'https://landings.test.mdirector.com',
  signupUrl: 'https://signup.test.mdirector.com',
  signupBackendUrl: 'https://signup-backend.test.mdirector.com',
  logoutUrl: 'https://signup-backend.test.mdirector.com/auth/logoutLandings',
  i18nCookieDomain: '.mdirector.com',
  cdnDomain: 'https://landings-backend.test.mdirector.com',
  assetsHost: 'https://static.test.mdirector.com/assets/',
  validationServerHostSuffix: '/amp-form-validation',
  gtmUrl: 'https://www.googletagmanager.com/amp.json',
  themeAssetsUrl: 'https://static.test.mdirector.com/assets/themes/',
  paymentsUrl: 'https://payments.test.mdirector.com',
  home: 'https://signup.test.mdirector.com/accounts/user/me',
  maxImageSizeToUpload: 5242880, // 5MB
  // GruID (strings)
  groupsAllowedToAMP: ['20941'],
  disablePageRefreshWarning: true,
  avoidConfirmMessages: true,
});

